var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    class: {
      'px-0': _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-row', {
    staticClass: "my-4 mx-auto",
    staticStyle: {
      "max-width": "540px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', {
    staticClass: "text-center accent--text mb-0 px-5"
  }, [_vm._v("Восстановление пароля")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "pt-4 pb-8",
    class: _vm.isMobile ? 'px-6' : 'px-8',
    attrs: {
      "outlined": "",
      "elevation": "2"
    }
  }, [_c('v-tabs', {
    staticClass: "custom-tabs-arrows",
    attrs: {
      "background-color": "transparent",
      "color": "primary",
      "grow": "",
      "show-arrows": ""
    },
    model: {
      value: _vm.regTab,
      callback: function callback($$v) {
        _vm.regTab = $$v;
      },
      expression: "regTab"
    }
  }, _vm._l(_vm.regOptions, function (option, i) {
    return _c('v-tab', {
      key: i,
      staticClass: "tab"
    }, [_vm._v(" " + _vm._s(option.name) + " ")]);
  }), 1), _c('v-tabs-items', {
    staticClass: "pt-6",
    model: {
      value: _vm.regTab,
      callback: function callback($$v) {
        _vm.regTab = $$v;
      },
      expression: "regTab"
    }
  }, _vm._l(_vm.regOptions, function (option, i) {
    return _c('v-tab-item', {
      key: i
    }, [i === 0 ? _c('div', [_vm.regType === 1 ? _c('v-row', {
      staticClass: "mx-0"
    }, [!_vm.isStartFlag ? _c('v-col', {
      staticClass: "pa-0 pt-1 ma-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-text-field', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "outlined": "",
        "rounded": "",
        "dense": "",
        "label": "Электронная почта",
        "error-messages": _vm.emailErrors
      },
      on: {
        "input": function input($event) {
          return _vm.$v.email.$touch();
        },
        "blur": function blur($event) {
          return _vm.$v.email.$touch();
        }
      },
      model: {
        value: _vm.email,
        callback: function callback($$v) {
          _vm.email = $$v;
        },
        expression: "email"
      }
    })], 1) : _vm._e(), !_vm.isStartFlag ? _c('v-col', {
      staticClass: "pt-0 mt-4",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "rounded": "",
        "depressed": "",
        "color": "primary",
        "disabled": _vm.$v.$invalid
      },
      on: {
        "click": _vm.startReset
      }
    }, [_vm._v(" Отправить ")])], 1) : _vm._e(), _vm.showEmailConfirmationAlert ? _c('v-col', {
      staticClass: "pa-0 mt-4",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-alert', {
      staticClass: "body-2",
      attrs: {
        "type": "info",
        "outlined": ""
      }
    }, [_vm._v(" На Ваш почтовый ящик отправлено письмо, содержащее ссылку для подтверждения нового пароля ")])], 1) : _vm._e(), _c('v-col', {
      staticClass: "pa-0 mt-5 text-right",
      attrs: {
        "cols": !_vm.isStartFlag ? 6 : 12
      }
    }, [_c('v-btn', {
      staticClass: "px-2",
      attrs: {
        "text": "",
        "small": "",
        "color": "primary",
        "to": "/login"
      }
    }, [_vm._v(" Страница входа ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), i === 1 ? _c('div', [_vm.regType === 1 ? _c('v-row', {
      staticClass: "mx-0"
    }, [!_vm.isStartFlag ? _c('v-col', {
      staticClass: "pa-0 pt-1 ma-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: '+7 (###) ### ## ##',
        expression: "'+7 (###) ### ## ##'"
      }],
      staticClass: "pa-0 ma-0",
      attrs: {
        "outlined": "",
        "rounded": "",
        "dense": "",
        "label": "Телефон"
      },
      on: {
        "focus": _vm.showTooltip,
        "input": function input($event) {
          return _vm.$v.phone.$touch();
        },
        "blur": function blur($event) {
          return _vm.$v.phone.$touch();
        }
      },
      model: {
        value: _vm.phone,
        callback: function callback($$v) {
          _vm.phone = $$v;
        },
        expression: "phone"
      }
    })], 1) : _vm._e(), !_vm.isStartFlag ? _c('v-col', {
      staticClass: "pt-0 mt-4",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "rounded": "",
        "depressed": "",
        "color": "primary",
        "disabled": _vm.$v.$invalid
      },
      on: {
        "click": _vm.startReset
      }
    }, [_vm._v(" Отправить ")])], 1) : _vm._e(), _vm.isStartFlag ? _c('v-col', {
      staticClass: "pa-0 mt-0",
      attrs: {
        "cols": _vm.isMobile ? 12 : 5
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: '####',
        expression: "'####'"
      }],
      attrs: {
        "outlined": "",
        "rounded": "",
        "dense": "",
        "label": "Введите код из смс",
        "rules": _vm.confirmationCodeRules
      },
      model: {
        value: _vm.confirmationCode,
        callback: function callback($$v) {
          _vm.confirmationCode = $$v;
        },
        expression: "confirmationCode"
      }
    })], 1) : _vm._e(), !_vm.isMobile && _vm.isStartFlag ? _c('v-col', {
      attrs: {
        "cols": "2"
      }
    }) : _vm._e(), _vm.isStartFlag ? _c('v-col', {
      staticClass: "pa-0 mt-4",
      class: {
        'text-center': _vm.isMobile
      },
      attrs: {
        "cols": _vm.isMobile ? 12 : 5
      }
    }, [_c('v-btn', {
      attrs: {
        "rounded": "",
        "depressed": "",
        "color": "primary",
        "disabled": _vm.disableConfirmationCodeButton
      },
      on: {
        "click": _vm.checkConfirmationCode
      }
    }, [_vm._v(" Подтвердить ")])], 1) : _vm._e(), _vm.isStartFlag && _vm.uncorrectConfirmationCode ? _c('v-col', {
      attrs: {
        "cols": 12,
        "text-center": ""
      }
    }, [_c('span', {
      staticClass: "uncorrect-code-alert"
    }, [_vm._v(" Вы ввели неправильный код подтверждения ")])]) : _vm._e(), _vm.isStartFlag ? _c('v-col', {
      staticClass: "pa-0 mt-5 text-center",
      attrs: {
        "cols": 12
      }
    }, [_c('v-btn', {
      staticClass: "px-2 code-timer",
      attrs: {
        "text": "",
        "small": "",
        "color": "primary",
        "disabled": !!_vm.confirmationCodeSecondsLeft
      },
      on: {
        "click": _vm.requestCodeToPhone
      }
    }, [_vm._v(" " + _vm._s(_vm.codeRequestText) + " ")])], 1) : _vm._e(), _c('v-col', {
      staticClass: "pa-0 mt-5 text-right",
      attrs: {
        "cols": !_vm.isStartFlag ? 6 : 12
      }
    }, [_c('v-btn', {
      staticClass: "px-2",
      attrs: {
        "text": "",
        "small": "",
        "color": "primary",
        "to": "/login"
      }
    }, [_vm._v(" Страница входа ")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.regType === 2 ? _c('PasswordCreate', {
      attrs: {
        "isMobile": _vm.isMobile,
        "userNameType": _vm.userNameType,
        "username": _vm.username,
        "code": _vm.code,
        "type": "forget"
      }
    }) : _vm._e()], 1);
  }), 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }